module.exports = __webpack_public_path__ + "img/logo-7.0a723c2a.png";